(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[157],{

/***/ 7964:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/residential-services",
      function () {
        return __webpack_require__(4891);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ residential_services; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/layouts/default/index.tsx + 7 modules
var layouts_default = __webpack_require__(6493);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(9603);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9417);
;// CONCATENATED MODULE: ./public/images/detail-1.jpg
/* harmony default export */ var detail_1 = ({"src":"/_next/static/media/detail-1.af390b8d.jpg","height":1097,"width":1536,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAeEAACAgICAwAAAAAAAAAAAAABAwACBBETIQUGsf/EABUBAQEAAAAAAAAAAAAAAAAAAAAC/8QAGhEAAgIDAAAAAAAAAAAAAAAAAQIAAxETMf/aAAwDAQACEQMRAD8Aosn0mua5LW+Qdai1mreU8htvZAG+h38EREa1bolCxlGAZ//Z","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/detail-2.jpg
/* harmony default export */ var detail_2 = ({"src":"/_next/static/media/detail-2.eecb9101.jpg","height":224,"width":300,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAfEAACAQMFAQAAAAAAAAAAAAABAgADBREEEyEyQVH/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/EABcRAAMBAAAAAAAAAAAAAAAAAAABAjH/2gAMAwEAAhEDEQA/AKmpf9y56ELTZKodyUHR1P33IxxERGCqWH//2Q==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/pages/residential-services/index.tsx
// ** Next Imports



// ** File Imports

// ** FA Imports


// ** Image Imports


const ResidentialServices = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts_default/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts_default/* SEOHead */.R, {
                title: "Unlimited Internet Services for Home. No Credit Check.",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "EIN offers easy and fast internet services for your home. No credit checks. Fast and Hassle Free Internet Only. Unlimited residential internet plans near you."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "internet services for home, no credit check internet, unlimited internet, internet no credit check near me"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "bg-silver1 pad-top-40 pad-bot-40",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sec-head",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "no-margin",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: " Residential Services "
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "pad-top-60 pad-bot-60",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row equal-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6 col-lg-6 col-sm-12 col-12 order-lg-2 order-md-2 order-sm-1 order-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "detail-image",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: detail_1,
                                            alt: "High speed internet",
                                            className: "img-fluid",
                                            placeholder: "blur"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6 col-lg-6 col-sm-12 col-12 order-lg-1 order-md-1 order-sm-2 order-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "detail-text",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                className: "col-grey1",
                                                children: "EIN RESIDENTIAL SERVICE"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "col-black",
                                                children: "High Speed Internet"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "col-grey1",
                                                children: "EIN Residential service is perfect for any home. We utilize existing service lines already in place your residence, and each of our new customers is professionally installed by a technician who will set up your modem and your home WIFI. They'll even help you understand how to connect all of your devices, such as your laptop or gaming system, to your new network!"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "col-grey1",
                                                children: "Our plans are all UNLIMITED, which means you never have to worry about going over a data cap or having your connection throttled. No contracts, no credit check, and you can change plans at any time without penalty!"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                href: "/check-availability",
                                                className: "custom-btn2",
                                                children: [
                                                    "Check Availability ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons/* faArrowRight */.eFW
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row equal-col m-t-50",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6 col-lg-6 col-sm-12 col-12 order-lg-1 order-md-1 order-sm-1 order-1",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "detail-image",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: detail_2,
                                            alt: "Request Information",
                                            className: "img-fluid",
                                            placeholder: "blur"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6 col-lg-6 col-sm-12 col-12 order-lg-2 order-md-2 order-sm-2 order-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "detail-text detail-text2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                className: "col-grey1",
                                                children: "REQUEST"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                className: "col-black",
                                                children: "Request Information"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "col-grey1",
                                                children: "Send us a request for more information and we will send you back all the information you need to help make a decision."
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
/* harmony default export */ var residential_services = (ResidentialServices);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [976,948,910,493,774,888,179], function() { return __webpack_exec__(7964); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);